import { render, staticRenderFns } from "./SignUpNewUserOne.vue?vue&type=template&id=81ed7392&scoped=true"
import script from "./SignUpNewUserOne.vue?vue&type=script&lang=js"
export * from "./SignUpNewUserOne.vue?vue&type=script&lang=js"
import style0 from "./SignUpNewUserOne.vue?vue&type=style&index=0&id=81ed7392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ed7392",
  null
  
)

export default component.exports